import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col flex-nowrap items-stretch h-screen max-w-full" }
const _hoisted_2 = { class: "flex-auto flex flex-row items-stretch max-w-full overflow-x-auto" }

import HeaderComponent from '@/components/HeaderComponent.vue';
import ConverzaSessionsTabsComponent from '@/components/converza-sessions/tabs/ConverzaSessionsTabs.vue';
import { RETRIEVE_PARTNER_PROVIDERS, RETRIEVE_SESSIONS } from '@/store';
import { onMounted } from 'vue';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConverzaSessionsView',
  setup(__props) {

const store = useStore();

onMounted(async () => {
  await store.dispatch(RETRIEVE_PARTNER_PROVIDERS);
  await store.dispatch(RETRIEVE_SESSIONS);
  await store.dispatch(RETRIEVE_SESSIONS, { mine: true });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HeaderComponent, {
      class: "flex-1 flex-grow-0",
      title: "Atendimento"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ConverzaSessionsTabsComponent, { class: "flex-1 flex-grow-[1]" }),
      _createVNode(_component_router_view, { class: "flex-auto flex-grow-[2]" })
    ])
  ]))
}
}

})